<template>
  <svg
    class="mobile-menu-glyph"
    :class="{ 'is-open': open }"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    aria-hidden="true"
  >
    <line class="mobile-menu-glyph-top" x1="2" y1="5" x2="16" y2="5" />
    <line class="mobile-menu-glyph-bottom" x1="2" y1="12" x2="16" y2="12" />
  </svg>
</template>

<script>
export default {
  name: 'MobileMenuGlyph',
  props: {
    open: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.mobile-menu-glyph {
  display: block;
  overflow: visible;
}
.mobile-menu-glyph line {
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-width: 1.2;
  transition: transform 240ms cubic-bezier(0.4, 0, 0.6, 1);
}
.mobile-menu-glyph-top { transform-origin: 9px 5px; }
.mobile-menu-glyph-bottom { transform-origin: 9px 12px; }
.mobile-menu-glyph.is-open .mobile-menu-glyph-top {
  transform: translateY(3.5px) rotate(45deg);
}
.mobile-menu-glyph.is-open .mobile-menu-glyph-bottom {
  transform: translateY(-3.5px) rotate(-45deg);
}
@media (prefers-reduced-motion: reduce) {
  .mobile-menu-glyph line { transition-duration: 80ms; }
}
</style>
